import { PropsBase } from "../model/props-base";

export class DynamicSVGProps extends PropsBase {
    svgSize?: number;
    svgPath?: string;
    height?: number | string;
    width?: number | string;
}

export function DynamicSVG(props: DynamicSVGProps) {
    const { svgSize, svgPath, width, height } = props;

    if (!svgSize || !svgPath) {
        return <div></div>;
    } else {
        return (
            <div className={props.className}>
                <svg height={height} width={width} viewBox={`0 0 ${svgSize} ${svgSize}`}>
                    <path d={svgPath} />
                </svg>
            </div>
        );
    }
}